module.exports = __webpack_public_path__ + "img/ccia.481a51c.png";